import { render, staticRenderFns } from "./Administrator.vue?vue&type=template&id=686bf82f&scoped=true"
import script from "./Administrator.vue?vue&type=script&lang=js"
export * from "./Administrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686bf82f",
  null
  
)

export default component.exports